export const taskDropdownI18nDe = {
    enterTaskPlaceholder: "Aufgabe eingeben",
    tasks: "Aufgaben",
};
